/**
 * Service to dispatch and listen to global events.
 */

/*----------------------------------------------------------------------
 * Events
 */

const eventTypes = {
    EVENT_CART_UPDATE: 'bitti-cart-update', // detail: { add_article: bool }
    EVENT_MOBILE_MENU_CLOSE: 'mobile-menu-close',
    EVENT_CART_ADD_ARTICLE: 'bitti-cart-add-article', // detail: see details below
    EVENT_CART_REMOVE_ARTICLE: 'bitti-cart-remove-article', // details: see details below
    EVENT_CART_IN_CONTENT_REFRESH: 'cart-in-content-refresh',
};

/*
 * 'detail' is accessible through event.detail
 *
 * Details for EVENT_CART_ADD_ARTICLE and EVENT_CART_REMOVE_ARTICLE:
 * {
 *    success: bool
 *    producteEventData: same from PHP App\Datas\ProducteEventData::getObject(),
 * }
 */


/*----------------------------------------------------------------------
 * Exported functions
 */

/**
 * @param string type
 * @param Function callback
 * @return void
 */
function addEventListener(type, callback)
{
    document.addEventListener(type, callback);
}

/**
 * @param string type
 * @param Function callback
 * @return void
 */
function removeEventListener(type, callback)
{
    document.removeEventListener(type, callback);
}

/**
 * @param string type
 * @param mixed data
 * @return void
 */
function dispatchEvent(type, data)
{
    if (data === undefined) data = {};
    const theEvent = new CustomEvent(type, { detail: data, bubbles: false });
    document.dispatchEvent(theEvent);
}

/*----------------------------------------------------------------------
 * Export
 */

export default {
    ...eventTypes,
    addEventListener,
    dispatchEvent,
};
